// pages/locations/LocationCreateModal.js
import React from 'react'
import LocationCreate from './LocationCreate'
import '../../assets/css/LocationCreateModal.css'

/**
 * A simple modal that reuses the LocationCreate component
 * but enforces a single `siteId` and calls `onClose` when done.
 */
function LocationCreateModal({ siteId, onCreated, onClose }) {
  // When the LocationCreate form successfully creates a location,
  // we want to inform the parent (`onCreated`) and then close the modal.
  const handleCreated = () => {
    if (onCreated) {
      onCreated()
    }
    onClose()
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">Create New Location</h2>

        <LocationCreate
          initialSiteId={siteId}
          onCreated={handleCreated}
          onClose={onClose}
          isModal={true}
        />
      </div>
    </div>
  )
}

export default LocationCreateModal